import React, { useState, useEffect } from "react";
import axios from "axios";
import Button from "../../components/Button/Button";
import BackButton from "../../components/BackButton/BackButton";
import "./styles.css";

function StoragePage({ onStorageSelect, onBack, brand, model }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const tagend = window.tagend;

  useEffect(() => {
    axios
      .get(
        `https://api.quieromac.com/retomas/inventory/celucambio/storage?id=${model.id}`
      )
      .then((response) => {
        const result = response.data.data;

        // Ordenar de menor a mayor capacidad
        const sortedData = result.sort((a, b) => {
          const aValue = parseInt(a.name.replace(/[^0-9]/g, ""));
          const bValue = parseInt(b.name.replace(/[^0-9]/g, ""));
          const aUnit = a.name.replace(/[0-9]/g, "");
          const bUnit = b.name.replace(/[0-9]/g, "");

          if (aUnit === bUnit) {
            return aValue - bValue;
          }
          return aUnit.localeCompare(bUnit);
        });

        setData(sortedData);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [brand, model.id]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div>
      <h1>¿Cuál es su capacidad de almacenamiento?</h1>
      <p className="description">
        <span>Así es cómo identificas la capacidad de tu celular</span>
      </p>
      <p className="sub-description">
        En tu teléfono, ve a{" "}
        <span>Configuración &gt; Acerca del teléfono &gt; Almacenamiento</span>
      </p>
      <div>
        {data.map((item, index) => (
          <Button
            key={item.id}
            type="full"
            onClick={() => {
              onStorageSelect(item);

              if (window.plausible) {
                window.plausible(`selected_mobile${tagend}`);
              } else {
                console.error("Plausible is not defined");
              }
            }}
          >
            {item.name}
          </Button>
        ))}
      </div>
      <BackButton onClick={onBack} />
    </div>
  );
}

export default StoragePage;
